import React, { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useLoggedIn } from 'store/session';

import ErrorBoundary from './ErrorBoundary';
import { Spinner } from './styles';

const SuspenseComponent = ({ component: Component, isPrivate }) => {
  const isLoggedIn = useLoggedIn();

  if (isPrivate && !isLoggedIn) return <Navigate to="/login" replace />;

  return (
    <ErrorBoundary>
      <Suspense fallback={<Spinner />}>
        <Component />
      </Suspense>
    </ErrorBoundary>
  );
};

SuspenseComponent.defaultProps = { isPrivate: false };
SuspenseComponent.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  isPrivate: PropTypes.bool,
};

export default SuspenseComponent;
